import { useState } from "react"
import { faCirclePlus } from "@fortawesome/free-solid-svg-icons"
import { FatFCountryList } from "../../../assets/staticData/CountryList"
import DropSelectSearch from "../../../ui-elements/DropSelect/DropSelectSearch/DropSelectSearch"
import Input from "../../../ui-elements/Input/Input"
import Button from "../../../ui-elements/Button/Button"

/** Represents a single country connection entry with a selected country and a text explanation */
interface CountryConnection {
    country: string
    description: string
}

const CountryConnections: React.FC = () => {
    /** Array of all country connection entries the user has added */
    const [connections, setConnections] = useState<CountryConnection[]>([
        { country: "", description: "" }
    ])

    /**
     * Updates a specific field (country or description) for a given entry.
     * Uses the index to target the correct entry in the connections array.
     */
    const handleFieldChange = (index: number, field: keyof CountryConnection, value: string) => {
        setConnections(prev => {
            const updated = [...prev]
            updated[index] = { ...updated[index], [field]: value }
            return updated
        })
    }

    /**
     * Adds a new empty country connection entry to the list.
     * This is triggered by the "Bæta við" button.
     */
    const handleAddConnection = () => {
        setConnections(prev => [...prev, { country: "", description: "" }])
    }

    /**
     * The "Bæta við" button should only be enabled when the last entry
     * in the list has both a country selected and a description filled in.
     * This prevents users from adding empty rows.
     */
    const lastConnection = connections[connections.length - 1]
    const isAddDisabled = !lastConnection.country || !lastConnection.description

    return <>
        {/* Render a country dropdown + description input pair for each connection entry */}
        {connections.map((connection, index) => (
            <div key={index} className="conditional-field inline-fields countryConnections">
                <DropSelectSearch
                    label="Tilgreinið ríki"
                    options={FatFCountryList}
                    size="lg"
                    defaultValue={connection.country}
                    onChange={(value: string) => handleFieldChange(index, "country", value)}
                />
                <Input
                    label="Vinsamlegast útskýrið nánar"
                    inputSize="lg"
                    value={connection.description}
                    onChange={(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
                        handleFieldChange(index, "description", e.target.value)
                    }
                />
            </div>
        ))}

        {/* Button to add additional country entries — disabled until the last entry is fully filled */}
        <Button
            className="addMoreCountryConnections"
            buttonType="secondary"
            size="sm"
            icon={faCirclePlus}
            onClick={handleAddConnection}
            disabled={isAddDisabled}
        >
            Bæta við
        </Button>
    </>
}

export default CountryConnections